import {twMerge} from '../../../../common/twMerge';
import {EventPageV2Props} from '../type';

export function EventPageV2({
  contentInfoList,
  isAlert,
  contentUrl,
  onClickContent,
  ...props
}: EventPageV2Props) {
  return (
    <div {...props}>
      {contentInfoList &&
        contentInfoList
          .sort((prev, next) => Number(prev.itemOrder) - Number(next.itemOrder))
          .map(contentInfo => {
            const showPointer =
              isAlert === false &&
              (contentInfo.schemeIos !== '' ||
                contentInfo.schemeAndroid !== '' ||
                contentInfo.schemeWeb !== '');
            return (
              <img
                key={contentInfo.resourceUrl}
                src={`${contentUrl}${contentInfo.resourceUrl}`}
                alt=""
                // eslint-disable-next-line tailwindcss/no-custom-classname
                className={twMerge(
                  'content',
                  'border-0 border-none align-top',
                  showPointer && 'cursor-pointer'
                )}
                data-scheme-ios={contentInfo.schemeIos}
                data-scheme-android={contentInfo.schemeAndroid}
                // scheme_web은 운영툴에서 PC web 항목으로 세팅하는 값입니다.
                data-scheme-web={contentInfo.schemeWeb}
                width="100%"
                onClick={onClickContent}
              />
            );
          })}
    </div>
  );
}
